import { render, staticRenderFns } from "./scraping.vue?vue&type=template&id=c25ed6d2&"
import script from "./scraping.vue?vue&type=script&lang=js&"
export * from "./scraping.vue?vue&type=script&lang=js&"
import style0 from "./scraping.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports